module.exports = __webpack_public_path__ + "static/media/3_12.5ecbff03.png";